$(document).ready(function () {

    function actOnclickedString(recString) {
        console.log(recString + " clicked");

        // Hide all gateway sections
        $("[id^='gatewayName']").hide();

        // Show only the selected gateway
        $("#gatewayName" + recString).show();
    }

    // Attach click handlers
    $("[id^='id_gateway_']").on("click", function () {
        actOnclickedString($(this).val());
    });

    // Initial load
    actOnclickedString($("#id_gateway_0").val());

});
